/**
 * Auth Module Exports
 * Phase 6: Frontend Application
 */

export { apiScopes, apiTokenRequest, getAuthConfigStatus, isAuthConfigured, loginRequest, msalConfig, SECURITY_GROUPS } from './msal-config';
export { MsalAuthProvider, getMsalInstanceForApi } from './msal-provider';
export { ROLES, useAuth, useHasAnyRole, useHasRole, useIsInGroup, useIsInAnyGroup, type AuthActions, type AuthState, type Role, type User } from './use-auth';

